import React from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../components/PageHeader';
import Reveal from '../components/Reveal';

const LAST_UPDATED = 'August 30, 2026';

function TermsPage() {
  return (
    <>
      <PageHeader
        eyebrow="Legal"
        title="Terms of Service"
        lead="The ground rules for using ronjohanson.com."
      />

      <section className="section">
        <div className="container">
          <Reveal as="div" className="legal">
            <p className="legal__updated">Last updated: {LAST_UPDATED}</p>

            <p>
              This website is published by the Committee to Elect Ron Johanson
              (&ldquo;the Campaign,&rdquo; &ldquo;we,&rdquo; or
              &ldquo;us&rdquo;). By using this site, you agree to these terms.
              If you do not agree with them, please do not use the site.
            </p>

            <h2>Purpose of This Site</h2>
            <p>
              This is a political campaign website. Its purpose is to share
              information about Ron Johanson&rsquo;s candidacy for the Chemung
              County Legislature, 2nd District, and to give neighbors a way to
              get in touch. Nothing here is legal, financial, or professional
              advice, and nothing here is an official communication of Chemung
              County or the Town of Big Flats.
            </p>

            <h2>Using the Site</h2>
            <p>You agree not to:</p>
            <ul>
              <li>
                Use the site for any unlawful purpose or in violation of New
                York State election law.
              </li>
              <li>
                Send us content through the contact form that is threatening,
                harassing, defamatory, obscene, or that impersonates someone
                else.
              </li>
              <li>
                Attempt to disrupt, overload, scrape, or gain unauthorized
                access to the site or the systems behind it.
              </li>
              <li>
                Copy or reuse the site&rsquo;s content in a way that suggests
                the Campaign endorses you, your product, or another candidate.
              </li>
            </ul>
            <p>
              We may remove content, block access, or decline to respond to
              messages at our discretion.
            </p>

            <h2>Messages You Send Us</h2>
            <p>
              When you submit the contact form or otherwise write to us, you
              confirm that the information you provide is accurate and that
              you are the person you say you are. We handle what you send as
              described in our{' '}
              <Link to="/privacy">Privacy Policy</Link>. Please do not send us
              confidential or sensitive personal information through this
              site.
            </p>

            <h2>Content and Trademarks</h2>
            <p>
              The text, photographs, logo, and design of this site belong to
              the Campaign or are used with permission, and are protected by
              copyright and trademark law. You are welcome to share links to
              our pages and to quote us in news coverage and community
              discussion. Any other reproduction requires our written
              permission.
            </p>

            <h2>Links and Third-Party Content</h2>
            <p>
              This site links to outside pages such as LinkedIn, Facebook, and
              local news articles. We do not control those sites and are not
              responsible for their content, accuracy, or availability. A link
              is not an endorsement of everything found on the other end of
              it.
            </p>

            <h2>Accuracy and Availability</h2>
            <p>
              We work to keep the information on this site current and
              correct, but positions, events, and details can change. The site
              is provided &ldquo;as is,&rdquo; without warranties of any kind,
              and we do not guarantee that it will be uninterrupted or
              error-free. To the fullest extent permitted by law, the Campaign
              is not liable for any damages arising from your use of this
              site.
            </p>

            <h2>Contributions</h2>
            <p>
              This website does not accept or process campaign contributions.
              Any contribution to the Campaign is handled separately and is
              subject to New York State campaign finance law.
            </p>

            <h2>Changes to These Terms</h2>
            <p>
              We may update these terms from time to time. The revised version
              will be posted here with a new date at the top of the page.
            </p>

            <h2>Governing Law</h2>
            <p>
              These terms are governed by the laws of the State of New York.
              Any dispute arising from them belongs in the state or federal
              courts serving Chemung County, New York.
            </p>

            <h2>Contact Us</h2>
            <p>
              Questions about these terms? Reach us through the{' '}
              <Link to="/contact">Get Involved</Link> page, or:
              <br />
              <a href="mailto:rnjohanson@yahoo.com">campaign@ronjohanson.com</a>
              <br />
              <a href="tel:+16077421425">(607)-742-1425</a>
            </p>
          </Reveal>
        </div>
      </section>
    </>
  );
}

export default TermsPage;
